<template>
    <header :class="['w-full pr-3']" class="soli-header pl-0.5">
        <div class="mx-auto py-0 flex gap-1">
            <v-app-bar-nav-icon
                v-if="sandwich"
                class="-ml-2"
                @click.stop="$emit('sandwich')"
            />
            <h1
                :class="[
                    'leading-tight font-bold align-center flex z-40 whitespace-nowrap text-overflow-ellipsis',
                    darkMode ? 'white--text' : 'contrast--text',
                ]"
                :style="{ fontSize: dynamicFontSize }"
            >
                <Link
                    style="margin-left: -18px"
                    v-bind="$attrs"
                    v-if="$attrs.href"
                    preserve-scroll
                    ><v-btn icon><v-icon>chevron_left</v-icon></v-btn></Link
                >
                <slot name="title">
                    {{ text }}
                </slot>
            </h1>
            <slot name="tools" />
            <slot name="actions" />
        </div>
    </header>
</template>

<script>
import { Link } from "@inertiajs/vue2";

export default {
    components: { Link },
    name: "SoliHeader",
    props: [
        "text",
        "large",
        "sandwich",
        "isScrolled",
        "headerButton",
        "darkMode",
    ],
    computed: {
        dynamicFontSize() {
            const length = (this.text || "").length;
            const isSmall = this.$vuetify.breakpoint.xs;
            const isLarge = this.large && this.$vuetify.breakpoint.smAndUp;

            // Base size in rem depending on context
            const baseSize = isLarge ? 2.4 : 1.8;
            const minSize = isSmall ? 1 : 1.3;

            // Start shrinking after 12 characters
            const threshold = 12;
            if (length <= threshold) return `${baseSize}rem`;

            // Scale down proportionally: the longer the text, the smaller the font
            const scaled = baseSize * (threshold / length);
            const clamped = Math.max(scaled, minSize);

            return `${clamped.toFixed(2)}rem`;
        },
    },
};
</script>

<style scoped>
.medium-header {
    font-size: 1.8rem !important;
}

.large-header {
    font-size: 2.4rem !important;
}

.small-header {
    font-size: 1.3rem !important;
}

.stripe-link {
    padding-left: 1.25rem;
}

.header-button {
    z-index: 50;
    left: -0.5rem;
    min-width: 350px;
    max-width: 350px;
    @media screen and (max-width: 960px) {
        max-width: 100%;
        left: -1rem;
    }
}
</style>
